var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarMerchantCredentials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "key_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9318",
    "data-name": "Group 9318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7176",
    "data-name": "Rectangle 7176",
    width: 19,
    height: 19,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9319",
    "data-name": "Group 9319",
    transform: "translate(0.779 4.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13569",
    "data-name": "Path 13569",
    d: "M16.585,9.117H10.078a4.675,4.675,0,1,0,0,3.117h.273l1.558,1.558,1.558-1.558,1.558,1.558,3.117-3.148Zm-10.909,3.9a2.338,2.338,0,1,1,2.338-2.338A2.345,2.345,0,0,1,5.675,13.013Z",
    transform: "translate(-1 -6)",
    fill: "#ca749f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMerchantCredentials);
export default __webpack_public_path__ + "static/media/sidebar_merchant_credentials.80a8a73ed82a50e5aa894563839dfb28.svg";
export { ForwardRef as ReactComponent };